var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-view',{directives:[{name:"wechat-title",rawName:"v-wechat-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]})
}
var staticRenderFns = []

export { render, staticRenderFns }